import { Injectable } from '@angular/core';
declare global {
  interface Navigator {
      msSaveBlob?: (blob: any, defaultName?: string) => boolean;
  }
}
@Injectable({
  providedIn: 'root'
})
export class CommonBillingService {

  constructor() { }

  downloadBlob(data: any) {
    const headerContent = data.headers.get('content-disposition');
    const index = headerContent.lastIndexOf('filename');
    const fileName = headerContent.substr(index + 9);
    const blob = new Blob([data.body]);
    const url = window.URL.createObjectURL(blob);

    if (navigator.msSaveBlob) {
      return navigator.msSaveBlob(blob, fileName);
    } else {
      const link = document.createElement('a');
      link.href = url;
      link.target = "_blank";
      link.setAttribute('download', fileName || 'template.xls');
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
  }
}
